<template>
  <div>
    <calendar
      class="card card-body rounded-top"
      :events="events"
      @eventClick="showPresenceModal"
      @select="showScheduleModal"
    />

    <presence-modal
      :show="showModal"
      :players="players"
      :event="selectedEvent"
      :id="idToEdit"
      @close="hideModal"
      @save="add"
      @update="update"
    />

    <schedule-modal :show="scheduleModal" :date="selectedDate" @close="hideScheduleModal" />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

import Calendar from '@/components/Calendar';
import PresenceModal from '@/components/modals/PresenceModal';
import ScheduleModal from '@/components/modals/MinimalScheduleModal';
import { modalMixin } from '@/mixins/modal';
import { tryParseInt } from '@/utils/number';
import { beforeCalendarRoute } from '@/routesUtils/calendar';
import { TableName } from '../../../enums/tableName.enum';
import { EventFunctions } from '../../../enums/eventFunctions.enum';
import { EventFeeFunctions } from '@/enums/eventFeeFunctions.enum';
import { eventsTranslate } from '@/utils/calendar';
import { EVENT_FEE_COLOR } from '@/utils/constants';
import { getTimePeriod } from '../../../utils/time';

// @vuese
// Kalendarz z wydarzeniami grupy treningowej
// @group Team
export default {
  name: 'TeamEvents',
  components: { Calendar, PresenceModal, ScheduleModal },
  mixins: [
    modalMixin('presences', {
      added: 'messages.presence.added',
      addError: 'messages.presence.addError',
      updated: 'messages.presence.updated',
      updateError: 'messages.presence.updateError'
    })
  ],
  data() {
    return {
      selectedDate: new Date(),
      selectedEvent: {},
      scheduleModal: false
    };
  },
  methods: {
    // @vuese
    // Decyduje, czy otworzyć modal edycji czy dodawania
    showPresenceModal(event) {
      this.selectedEvent = event;

      this.$store
        .dispatch('presences/list', {
          scheduleContainerId: event.eventContainerId,
          date: event.eventDate,
          hour: event.eventHour,
          minute: event.eventMinute
        })
        .then(() => {
          const presenceId = this.presences.length > 0 ? this.presences[0].id : undefined;

          if (presenceId) {
            this.showEditModal(presenceId);
          } else {
            this.showAddModal();
          }
        })
        .catch(() => this.notifyError(messages.errorShort));
    },

    // @vuese
    // Ukrywa modal dodawania/edycji listy obecności
    hideModal() {
      this.selectedEvent = {};
      this.$set(this, 'showModal', false);
      this.$set(this, 'idToEdit', undefined);
    },

    // @vuese
    // Pokazuje modal dodawania składki/harmonogramu
    showScheduleModal(event) {
      this.selectedDate = event.date;
      this.scheduleModal = true;
    },
    // @vuese
    // Ukrywa modal do dodawania treningu/harmonogramu
    hideScheduleModal() {
      this.$set(this, 'scheduleModal', false);
      this.refreshEvents();
    },
    // @vuese
    // Odświeża liste eventów
    refreshEvents() {
      const timePeriod = getTimePeriod(
        this.$route.params.view,
        this.$route.query.year,
        this.$route.query.month,
        this.$route.query.day
      );

      Promise.all([
        this.$store.dispatch('events/list', {
          id: this.teamId,
          eventType: EventFunctions[TableName.Team],
          start: timePeriod.start,
          end: timePeriod.end
        }),
        this.$store.dispatch('fee/events/list', {
          id: this.teamId,
          eventType: EventFeeFunctions[TableName.Team],
          start: timePeriod.start,
          end: timePeriod.end
        })
      ]).catch(() => this.$store.dispatch('notifyError', { title: 'messages.errorShort' }));
    }
  },
  computed: {
    ...mapState({
      events: state => [
        ...eventsTranslate([...state.events.list]),
        ...eventsTranslate([...state.fee.events.list], EVENT_FEE_COLOR)
      ],
      players: state => state.team.player.list,
      presences: state => state.presences.list
    }),
    teamId() {
      return tryParseInt(this.$route.params.teamId);
    }
  },
  beforeRouteUpdate(to, from, next) {
    beforeCalendarRoute(
      to,
      tryParseInt(to.params.teamId),
      TableName.Team,
      next,
      this.$store.dispatch('team/player/list', { teamId: tryParseInt(to.params.teamId) })
    );
  }
};
</script>
